import storageUtil from '@zet/utils/storage'

const useDsaLogo = () => {
  const logo = storageUtil.getObject('dsaLogo')

  return { logo }
}

export { useDsaLogo }
